import { APPROVAL_DIRECTION } from "@/consts/Approval";

export const QUERY_KEYS = {
  PROJECT_GROUPS: {
    ROOT: ["project-groups"],
    LIST: () => ["project-groups", "list"],
    LIST_BY_PROJECT: (project_id: string) => [
      "project-groups",
      "list-by-project",
      project_id,
    ],
    DETAIL: (group_id: string) => ["project-groups", "detail", group_id],
    BID_NOTICE: (group_id: string) => [
      "project-groups",
      "bid-notice",
      group_id,
    ],
    SEARCH_BY_TASK_ID: (task_id: string) => [
      "project-groups",
      "search-by-task-id",
      task_id,
    ],
    TASKS: {
      LIST: (group_id: string) => ["project-groups", "tasks", "list", group_id],
    },
    ITEM_SHEETS: {
      ROOT: (group_id: string) => ["project-groups", "item-sheets", group_id],
      ORIGINAL_INFO: (group_id: string, project_id: string) => [
        "project-groups",
        "item-sheets",
        group_id,
        "original-info",
        project_id,
      ],
      ORIGINAL_LIST: (group_id: string) => [
        "project-groups",
        "item-sheets",
        group_id,
        "original-list",
      ],
      LATEST_LIST: (group_id: string, original_id: string) => [
        "project-groups",
        "item-sheets",
        group_id,
        "latest-list",
        original_id,
      ],
      LATEST: (group_id: string, latest_sheet_id: string) => [
        "project-groups",
        "item-sheets",
        group_id,
        "latest",
        latest_sheet_id,
      ],
      AUDIT_LOGS: (group_id: string) => [
        "project-groups",
        group_id,
        "item-sheets",
        "audit-logs",
      ],
      FINALIZED: (group_id: string) => [
        "project-groups",
        "item-sheets",
        group_id,
        "finalized",
      ],
    },
  },
  TASKS: {
    ROOT: ["tasks"],
    DETAIL: (task_id: string) => ["tasks", "detail", task_id],
    ALL: () => ["tasks", "all"],
  },
  SPEC: {
    ROOT: (project_id: string) => ["spec", project_id],
    REAGENTS: (project_id: string) => ["spec", "reagents", project_id],
    COMMODITIES: (project_id: string) => ["spec", "commodities", project_id],
  },
  SCENARIO_APPROVALS: {
    LIST_ROOT: ["scenario-approvals"],
    LIST: (direction: APPROVAL_DIRECTION) => [
      ...QUERY_KEYS.SCENARIO_APPROVALS.LIST_ROOT,
      direction,
    ],
    DETAIL: (approval_id: string) => [
      ...QUERY_KEYS.SCENARIO_APPROVALS.LIST_ROOT,
      approval_id,
    ],
    HISTORY: (group_id: string) => [
      ...QUERY_KEYS.SCENARIO_APPROVALS.LIST_ROOT,
      "history",
      group_id,
    ],
  },
  SCENARIO: {
    LIST: (project_id: string) => ["scenario", "list", project_id],
    DETAIL: (project_id: string, scenario_id: string) => [
      "scenario",
      "detail",
      project_id,
      scenario_id,
    ],
  },
  ALERT: {
    ROOT: ["alert"],
    LIST: ["alert", "list"],
  },
  SMF: {
    SEARCH: (product_id: string, item_type: string) => [
      "smf",
      "search",
      product_id,
      item_type,
    ],
  },
  REAGENT_ALT: {
    ROOT: ["reagent-alt"],
    LIST: () => ["reagent-alt", "list"],
  },
} as const;
